import type { ReactElement } from 'react';
import { AgentResourcesProvider } from './AgentResources.Container';
import { ContextSelectorContainer } from './ContextSelector.Container';
import { ChatHeaderController } from './Header.Controller';

type Props = {
  disableContextDisplay?: boolean;
  disableTabs?: boolean;
};

function ChatHeader(props: Props): ReactElement {
  return (
    <ContextSelectorContainer>
      <AgentResourcesProvider>
        <ChatHeaderController
          disableContextDisplay={props.disableContextDisplay}
          disableTabs={props.disableTabs}
        />
      </AgentResourcesProvider>
    </ContextSelectorContainer>
  );
}

export { ChatHeader };
